import { useState } from 'react';
import styles from '../styles/partnersView.module.css';
import CustomersSection from '../customComponents/CustomersSection';
import SuppliersSection from '../customComponents/SuppliersSection';

const sections = [
  { id: 'customers', label: 'Клиенты' },
  { id: 'suppliers', label: 'Поставщики' },
];

const PartnersView = () => {
  const [activeSection, setActiveSection] = useState('customers'); // по умолчанию Клиенты

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        {sections.map((section) => (
          <button
            key={section.id}
            className={`${styles.tabButton} ${
              activeSection === section.id ? styles.active : ''
            }`}
            onClick={() => setActiveSection(section.id)}
          >
            {section.label}
          </button>
        ))}
      </div>
      

      {activeSection === 'customers' && <CustomersSection />}
      {activeSection === 'suppliers' && <SuppliersSection />}
    </div>
  );
};

export default PartnersView;
